import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { ButtonColors, ButtonFontSizes, ButtonHeights, ButtonTypes } from '../../../ui/gzButton/types';

export const templateConfigurationProfiles = document.createElement('template');

templateConfigurationProfiles.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">

    <header class="page__header">
        <gz-button class="back_button hidden"
            type=${ButtonTypes.QUIET}
            color=${ButtonColors.SECONDARY}
            buttonheight=${ButtonHeights.MEDIUM}
            buttonfontsize=${ButtonFontSizes.MEDIUM}
            >
            <i class="ds-icon-arrow_left_collapse"></i>
            <span class="back_button_text"></span>
        </gz-button>
        <gz-title class="title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}"></gz-title>
    </header>
    <div class="header">
      <gz-company-selector id="companySelectorDropdown" class="company-selector"></gz-company-selector>
    </div>

    <gz-tab-group class="configuration-profiles-tab-group" id="configuration-profiles-tab-group">
      <gz-tab id="global-exclusions-tab">
        <gz-global-exclusions-app></gz-global-exclusions-app>
      </gz-tab>
      <gz-tab id="maintenance-windows-tab">
        <gz-maintenance-windows-app></gz-maintenance-windows-app>
      </gz-tab>
      <gz-tab id="web-access-control-scheduler-tab" class="configuration-profiles-tab">
        <gz-web-access-control-scheduler-app></gz-web-access-control-scheduler-app>
      </gz-tab>
      <gz-tab id="wac-pages-tab" hidden>
        <gz-web-access-control-custom-pages-app></gz-web-access-control-custom-pages-app>
      </gz-tab>

      <gz-tab id="gz-cloud-staging-list-tab">
        <gz-cloud-staging-list-app></gz-cloud-staging-list-app>
      </gz-tab>
    </gz-tab-group>

    <gz-side-menu class="configuration-profiles-details-panel" menuwidth="400" closeOnClickOutside></gz-side-menu>
  </div>
`;
